import React from "react";
import clsx from "clsx";

interface NavStepProps {
	currentStep: number;
	index: number;
}

export default function NavStep({ currentStep, index }: NavStepProps) {
	return (
		<li className={clsx({ active: currentStep === index })}>
			<span>Step {index + 1}</span>
		</li>
	);
}
